var LaravelElixirBundle = (function (exports) {
'use strict';

window.TagManager = new (function () {
    function anonymous () {}

    anonymous.prototype.fireDomEvent = function fireDomEvent (name, event) {
        window.dataLayer.push({
            'event': 'gtm.' + name,
            'gtm.element': event.target,
            'gtm.elementClasses': event.target.className || '',
            'gtm.elementId': event.target.id || '',
            'gtm.elementTarget': event.target.target || '',
            'gtm.elementUrl': event.target.href || event.target.action || '',
            'gtm.originalEvent': event
        });
    };

    anonymous.prototype.fireEvent = function fireEvent (name, data) {
        data.event = "gtm." + name;
        window.dataLayer.push(data);
    };

    anonymous.prototype.pushData = function pushData (key, value) {
        var obj;
        window.dataLayer.push(( obj = {}, obj[key] = value, obj ));
    };

    anonymous.prototype.pushDataObject = function pushDataObject (obj) {
        window.dataLayer.push(obj);
    };

    return anonymous;
}());

return exports;

}({}));
//# sourceMappingURL=TagManagerB.js.map
